var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/** @jsx jsx */


import { memo } from "react";
import ReactModal from "react-modal";
import { jsx } from "theme-ui";
var WIDTH_SMALL = "640px";
var WIDTH_LARGE = "900px";
var MIN_HEIGHT = "200px";
var CLOSE_BTN_SIZE = "32px";

var Modal = function Modal(_a) {
  var ariaLabel = _a.ariaLabel,
      children = _a.children,
      show = _a.show,
      _b = _a.size,
      size = _b === void 0 ? "small" : _b,
      _c = _a.showCloseButton,
      showCloseButton = _c === void 0 ? true : _c,
      onClose = _a.onClose;
  var otherStyles = {};

  switch (size) {
    case "auto":
      otherStyles = {
        width: "auto",
        mx: 3
      };
      break;

    case "small":
      otherStyles = {
        width: WIDTH_SMALL,
        mx: 3
      };
      break;

    case "large":
      otherStyles = {
        width: WIDTH_LARGE,
        mx: 3
      };
      break;

    default:
      // screen
      otherStyles = {
        position: "fixed",
        top: showCloseButton ? CLOSE_BTN_SIZE : 4,
        bottom: 4,
        left: 4,
        right: 4
      };
  }

  var modalStyle = __assign({
    backgroundColor: "background",
    minHeight: MIN_HEIGHT,
    outline: "none"
  }, otherStyles);

  var contentStyle = {
    position: "relative",
    height: "100%"
  };
  var closeButtonStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "-" + CLOSE_BTN_SIZE,
    right: "-8px",
    width: CLOSE_BTN_SIZE,
    height: CLOSE_BTN_SIZE,
    fontSize: 4,
    fontWeight: "bold",
    lineHeight: "100%",
    backgroundColor: "transparent",
    border: "none",
    color: "text",
    cursor: "pointer",
    outline: "none"
  };
  return jsx(ReactModal, {
    isOpen: show,
    onRequestClose: onClose,
    contentLabel: ariaLabel,
    style: {
      overlay: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(100,100,100,0.5)"
      }
    },
    sx: modalStyle
  }, jsx("div", {
    sx: contentStyle
  }, showCloseButton && jsx("button", {
    sx: closeButtonStyle,
    onClick: onClose
  }, "×"), children));
}; // Hide app element from screenreaders when the modal is open.


ReactModal.setAppElement("body");
export default memo(Modal);